import React from 'react'
import { Image } from 'newComponents'

import { ReactComponent as ShooterShort } from '../../images/pricing/new/shooter-short.svg'
import { ReactComponent as ShooterMedium } from '../../images/pricing/new/shooter-medium.svg'
import './styles.scss'

const CustomerLogoGrid = ({ data }) => {
  const content = data[0]
  const {
    items,
    primary: { grid_title: gridTitle }
  } = content

  return (
    <div className="customer-logo-grid">
      <ShooterShort className="pricing-shooter-short" />
      <ShooterMedium className="pricing-shooter-dark-medium" />
      <div className="container">
        <h2>{gridTitle.text}</h2>
        <div className="customer-logo-grid-logos">
          {items.map((logo) => (
            <Image key={logo.customer_logo.url} image={logo.customer_logo.url} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default CustomerLogoGrid
